import SdBars from './SdBars'
import SdCircles from './SdCircles'
import SdSquiggles from './SdSquiggles'
import SdSquares from './SdSquares'
import SdTriangles from './SdTriangles'
import SdDiamonds from './SdDiamonds'

export default {
    SdBars,
    SdCircles,
    SdSquiggles,
    SdSquares,
    SdTriangles,
    SdDiamonds
}
